import { Skeleton } from "@gerama/ui";

export function SongDetailSkeleton() {
  return (
    <div className="flex flex-col items-center gap-4 sm:flex-row sm:items-end">
      <Skeleton className="size-40 shrink-0 rounded-xl sm:size-52" />
      <div className="w-full space-y-2">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-4 w-40" />
      </div>
    </div>
  );
}
